import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '../title/title.interface';
import { CommonService } from '../services/common.service';
import { InventoryService } from 'src/app/inventory/inventory.service';
import * as myGlobals from '../../shared/globalcontants'; // CONSTANT FILE ADD ANY CONSTANT VALUE
import { cSharpModuleName } from '../../shared/globalcontants';
import { CSharpRequestService } from 'src/app/shared/services/csharp-request.service';
import * as appApiResources from '../../shared/globalcontants';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { GlobalConversionService } from '../services/GlobalMethodService/GlobalConversion-Service';
import { Router, NavigationExtras } from '@angular/router';
import _ from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { NgClass } from '@angular/common';
import { CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf } from '@angular/cdk/scrolling';
import { NoItemsComponent } from '../no-items/no-items.component';
import { IsEmpty } from '../pipes/is-empty.pipe';
import { HighlightPipe } from '../pipes/highlight-char.pipe';

@Component({
    selector: 'app-all-locations',
    templateUrl: './all-locations.component.html',
    styleUrls: ['./all-locations.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, CdkVirtualScrollViewport, CdkFixedSizeVirtualScroll, CdkVirtualForOf, NoItemsComponent, TranslateModule, IsEmpty, HighlightPipe]
})
export class AllLocationsComponent implements OnInit, OnDestroy {
  titleOptions: Title;
  tableData: any = [];
  isDataLoaded = false;
  isCreateRequest = false;
  loggedInSiteId = 0;
  transactiontype = 0;
  transactionID = 0;
  tableColumn: any = [];
  showNodata: boolean = false;
  intial: boolean = true;
  rowHeight: any = 0;
  index: number;
  constructor(private csharpService: CSharpRequestService,
    private _ts: TranslateService,
    private _CommonService: CommonService,
    private cdRef: ChangeDetectorRef,
    public deviceInfo: DeviceDetectorService,
    private router: Router, private _IS: InventoryService, private globalconversionService: GlobalConversionService) { }

  ngOnInit() {
    this._CommonService.titleOptions = {
      'back': true,
      'pageTitle': this._ts.instant('common.availableLocations'),
      'backFunction': this.backClick
    };
    this._CommonService.component = this;
    this.tableData = {
      tableId: 'allLocations',
      tableHeader: ['common.locationName', 'common.minPar', 'common.maxPar', 'common.qoh'],
      tableStyle: ['25', '25', '25', '25'],
      tableData: [],
      orderId: ['first', 'third', 'fourth', 'fifth'],
      customClass: 'location-page'
    };
    if (this._CommonService.locationData.locations.length > 0) {
      this.getAllLocations();
    } else {
      this.router.navigate(['/dashboard']);
    }
    this.getloggedInDetails();

    this.transactionID = this._CommonService.offlineTransactionId;
    this.transactiontype = this._CommonService.offlineTransactiontype;

    if (this.tableData?.tableData !== undefined) {
      if (this.tableData?.tableData?.length > 0) {
        this.tableColumn = Object.keys(this.tableData.tableData[0]);
      }
      this.showNodata = !(this.tableData?.tableData?.length > 0);
      this.cdRef.detectChanges();
    } else {
      this.showNodata = true;
    }
    this.updateTableHeight();
  }

  updateTableHeight(index?) {
    let timeoutValue = 5;
    if (this.deviceInfo.device === 'iPhone') {
      timeoutValue = 100;
    }
    const _this = this;
    if (this.intial) {
      setTimeout(() => {
        if (document.getElementsByClassName('table-row').length > 0) {
          _this.rowHeight = document.getElementsByClassName('table-row')[0]['offsetHeight'];
          _this.intial = false;
        }
      }, timeoutValue);
    }
    const remainingHeight = window.innerHeight; //windowHeight

    setTimeout(() => {
      const rowCount = _this.tableData.length;
      const defaultRowCount = 8;
      _this.index = -1;
      const actualRowHeight = _this.rowHeight * rowCount;
      const defaultHeight = _this.rowHeight * (rowCount < defaultRowCount ? rowCount : defaultRowCount);
      const tableId = document.getElementById('app-tale-body-' + this.tableData.tableId);
      if (tableId) {
        if (actualRowHeight < remainingHeight) {
          document.getElementById('app-tale-body-' + this.tableData.tableId).style.height = actualRowHeight + 'px';
        } else {
          if (remainingHeight > defaultHeight) {
            document.getElementById('app-tale-body-' + this.tableData.tableId).style.height = remainingHeight + 'px';
          } else {
            document.getElementById('app-tale-body-' + this.tableData.tableId).style.height = defaultHeight + 'px';
          }
        }
      }
    }, (timeoutValue + 10));
  }

  getloggedInDetails() {
    if (sessionStorage.hasOwnProperty(appApiResources.loggedInSiteId.toString())) {
      this.loggedInSiteId = parseInt(sessionStorage.getItem(appApiResources.loggedInSiteId.toString()));
    }
  }

  getAllLocations() {
    this._CommonService.locationData.locations.forEach(location => {
      this.tableData.tableData.push({
        'itemName': location.name,
        'minPar': this.globalconversionService.customformatter(Number(location.minpar)) + ' ' + this._CommonService.locationData.itemUnitDetails.find(x => x.UnitTypeId == 1).UnitCode,
        'maxPar': this.globalconversionService.customformatter(Number(location.maxpar)) + ' ' + this._CommonService.locationData.itemUnitDetails.find(x => x.UnitTypeId == 1).UnitCode,
        'qoh': `${this.globalconversionService.customformatter(Number(location.qoh))}` + ' ' + this._CommonService.locationData.itemUnitDetails.find(x => x.UnitTypeId == 1).UnitCode
      });
    });
    this.tableData = { ...this.tableData };
    this.isDataLoaded = true;
  }

  backClick(event, _this) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'RoutePath': 'Location'
      }
    };
    _this._IS.isNewRequisition = false;
    this.isCreateRequest = true;
    const pop = _this._CommonService.routeStack.pop();
    if (pop.split('?').length > 1) {
      _this.router.navigate([pop.split('?')[0]], navigationExtras);
    } else {
      _this.router.navigate([pop]);
    }
  }

  ngOnDestroy() {
    this._CommonService.offlineTransactionId = 0;
    this._CommonService.offlineTransactiontype = 0;
    if (this.csharpService.IsLoadFromApp && !this.isCreateRequest) {
      const sourceObj = {
        Modulename: cSharpModuleName.TransactionRequisition,
        Action: myGlobals.cSharpActionName.UpdateRequisition, responseMessage: '',
        Isposted: 0, transactionType: this.transactiontype, RequisitionID: this.transactionID, SiteID: this.loggedInSiteId
      };
      this.csharpService.RequestPOSTCSharp(appApiResources.cSharpURLs.PostTransaction, sourceObj, false);
    }
  }

}
